<template>
  <section class="brand-introduce-component-touch">
    <div class="brand-introduce-inner">
      <div class="brand-introduce-left">
        <img class="brand-introduce-bg" v-lazy-load :data-src="bgImageUrl" :alt="bgAlt || ''" draggable="false">
      </div>

      <div class="brand-introduce-right">
        <div class="brand-introduce-title" v-html="columnTitle" />
        <div class="brand-introduce-intro">
          {{ columnIntro }}
        </div>

        <div v-if="iconList && iconList.length" class="brand-introduce-icons">
          <div v-for="(item, index) in iconList" :key="item.rowUuid || index" class="brand-introduce-icon-item">
            <div class="brand-introduce-icon-circle">
              <img v-lazy-load :data-src="item.iconUrl" :alt="item.alt || ''" draggable="false">
            </div>
            <div class="brand-introduce-icon-title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'BrandIntroduceComponent',
  mixins: [mixin],
}
</script>

<style lang="scss" scoped>
.brand-introduce-component-touch {
  font-family: 'Roboto-Flex', sans-serif;
  width: 100%;
  background: #ffffff;
  overflow: hidden;
  padding: 42px 25px;
  box-sizing: border-box;

  .brand-introduce-inner {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    gap: 26px;
  }

  .brand-introduce-left {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .brand-introduce-bg {
    width: 320px;
    height: 269px;
    margin: 0 auto;
    display: block;
  }

  .brand-introduce-title {
    font-weight: 600;
    font-size: 22px;
    line-height: 30px;
    color: #44454c;

    ::v-deep p {
      margin: 0;
    }

    ::v-deep strong {
      font-weight: 600;
    }

    ::v-deep span {
      font-weight: inherit;
    }
  }

  .brand-introduce-intro {
    margin-top: 16px;
    max-width: 100%;
    font-size: 16px;
    line-height: 24px;
    color: #44454C;
  }

  .brand-introduce-icons {
    margin-top: 16px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .brand-introduce-icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .brand-introduce-icon-circle {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .brand-introduce-icon-title {
    margin-top: 12px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    color: #44454C;
    text-align: center;
  }
}
</style>
